/**
 * Campaign Onboarding - Fetch operations and select operation
 */
(function (global) {
  "use strict";

  var CampaignOnboarding = global.CampaignOnboarding;

  function handleFetchOperations(urls) {
    var btn = document.getElementById("fetch-operations-btn");
    var resultDiv = document.getElementById("fetch-operations-result");
    var successDiv = document.getElementById("fetch-operations-success");
    var errorDiv = document.getElementById("fetch-operations-error");
    var errorMessage = document.getElementById(
      "fetch-operations-error-message",
    );
    var customerIdEl = document.getElementById("operations-customer-id");
    var tableBody = document.getElementById("operations-table-body");

    if (!btn) return;

    btn.disabled = true;
    var originalText = btn.innerHTML;
    btn.innerHTML =
      '<i class="glyphicon glyphicon-refresh spinning"></i> Fetching...';

    fetch(urls["fetch-operations"], {
      method: "GET",
      headers: { Accept: "application/json" },
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        resultDiv.classList.remove("hidden");

        if (data.success) {
          successDiv.classList.remove("hidden");
          errorDiv.classList.add("hidden");

          customerIdEl.textContent = data.customer_id;

          tableBody.innerHTML = "";
          data.operations.forEach(function (op) {
            var row = document.createElement("tr");
            var isSelected = op.operation_id === data.current_operation_id;

            if (isSelected) {
              row.classList.add("info");
            }

            var tdId = document.createElement("td");
            var code = document.createElement("code");
            code.style.fontSize = "11px";
            code.textContent = op.operation_id;
            tdId.appendChild(code);
            row.appendChild(tdId);

            var tdStatus = document.createElement("td");
            var statusSpan = document.createElement("span");
            statusSpan.className =
              "label label-" +
              CampaignOnboarding.getStatusLabelClass(op.status);
            statusSpan.textContent = op.status;
            tdStatus.appendChild(statusSpan);
            row.appendChild(tdStatus);

            var tdDate = document.createElement("td");
            tdDate.textContent = CampaignOnboarding.formatDate(
              op.creation_date,
            );
            row.appendChild(tdDate);

            var tdAction = document.createElement("td");
            if (isSelected) {
              var selectedSpan = document.createElement("span");
              selectedSpan.className = "text-success";
              var icon = document.createElement("i");
              icon.className = "glyphicon glyphicon-ok";
              selectedSpan.appendChild(icon);
              selectedSpan.appendChild(document.createTextNode(" Selected"));
              tdAction.appendChild(selectedSpan);
            } else {
              var selectBtn = document.createElement("button");
              selectBtn.className =
                "btn btn-xs btn-default select-operation-btn";
              selectBtn.setAttribute("data-operation-id", op.operation_id);
              selectBtn.textContent = "Select";
              tdAction.appendChild(selectBtn);
            }
            row.appendChild(tdAction);

            tableBody.appendChild(row);
          });

          document
            .querySelectorAll(".select-operation-btn")
            .forEach(function (selectBtn) {
              selectBtn.addEventListener("click", function () {
                selectOperation(this.dataset.operationId, urls);
              });
            });
        } else {
          successDiv.classList.add("hidden");
          errorDiv.classList.remove("hidden");
          errorMessage.textContent = data.error || "Unknown error";
        }

        btn.disabled = false;
        btn.innerHTML = originalText;
      })
      .catch(function (error) {
        resultDiv.classList.remove("hidden");
        successDiv.classList.add("hidden");
        errorDiv.classList.remove("hidden");
        errorMessage.textContent = error.message || "Network error";
        btn.disabled = false;
        btn.innerHTML = originalText;
      });
  }

  function selectOperation(operationId, urls) {
    var csrfToken = document.querySelector('meta[name="csrf-token"]');

    fetch(urls["select-operation"], {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken ? csrfToken.getAttribute("content") : "",
      },
      body: JSON.stringify({ operation_id: operationId }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.success) {
          handleFetchOperations(urls);
          var opIdEl = document.getElementById("operation-id");
          if (opIdEl) opIdEl.textContent = operationId;
        } else {
          alert(
            "Failed to select operation: " + (data.error || "Unknown error"),
          );
        }
      })
      .catch(function (error) {
        alert("Error selecting operation: " + error.message);
      });
  }

  global.CampaignOnboarding = global.CampaignOnboarding || {};
  global.CampaignOnboarding.handleFetchOperations = handleFetchOperations;
  global.CampaignOnboarding.selectOperation = selectOperation;
})(typeof window !== "undefined" ? window : this);
